import i18n from '@/libs/i18n'
import type { NavLink } from '@/types/Navigation'

const { t } = i18n.global

export const getNavItems = (): NavLink[] => {
    return [
        {
            items: [
                { label: t('general.dashboard'), icon: 'pi pi-fw pi-chart-bar', to: 'dashboard' },
                { label: t('reseller.resellers'), icon: 'pi pi-fw pi-shop', to: 'resellers' },
                { label: t('pos_hardware.pos_hardware'), icon: 'pi pi-fw pi-desktop', to: 'pos-hardware' },
                { label: t('current_software.current_software', 2), icon: 'pi pi-fw chip-icon', to: 'current-software' },
                { label: t('lead_source.lead_source', 2), icon: 'pi pi-fw pi-id-card', to: 'lead-sources' },
                { label: t('equipment.card_payment_equipment', 2), icon: 'pi pi-fw pos-terminal-icon', to: 'card-payment-equipments' },
                { label: t('user.user', 2), icon: 'pi pi-fw pi-user', to: 'users' }
            ]
        }
    ]
}
